<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
export default {
  name: 'IndexAlert',

  data () {
    return {
      bannerData: null
    }
  },

  mounted () {
    this.getBanner()
  },

  methods: {
    getBanner () {
      axios.get('/ad/indexPopup')
        .then((response) => {
          if (response.data.length > 0) {
            this.bannerData = response.data[0]
            this.swal(response.data[0])
          }
        }
      )
    },

    swal (data) {
      let self = this
      self.$swal.fire({
        html: `
          <a href="${data.url}" target="_blank">
            <img src="${data.image_url}" alt="${data.name}" class="p-0 m-0 index_image" />
          </a>`,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          container: 'IndexAlert p-0',
          popup: 'p-0 lg:w-auto',
          header: 'p-0 m-0',
          closeButton: 'p-0',
          htmlContainer: 'p-0',
        }
      })
    }
  }
}
</script>
<style lang="scss">
.IndexAlert {
  .index_image {
    @media (min-width: 768px) {
      max-width: 80vw;
      max-height: 80vh;
    }
  }
  .swal2-content {
    padding: 0 !important;
  }
}

</style>
